// @ts-nocheck

import React, { useEffect, useState } from 'react'
import styles from './BrowseCatagory.module.scss'
import Slider from 'react-slick'
import { useAppDispatch } from 'src/store/store'
import { useSelector } from 'react-redux'
import GET_SINGLE_CATEGORY from 'src/graphql/queries/getSingleCategory'
import client1 from 'src/utils/apolloClient'
import Link from 'next/link'

function SampleNextArrow(props) {
  const { className, style, onClick } = props
  return (
    <div className={className} onClick={onClick}>
      <img src="/assets/icon/right-icon-black.svg" alt="RightArrow" />
    </div>
  )
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props
  return (
    <div className={className} onClick={onClick}>
      <img src="/assets/icon/left-icon-black.svg" alt="LeftArrow" />
    </div>
  )
}

export default function BrowseCatagory({
  backgroundColor,
  imageBackgroundColor,
  imageArray,
  fontColor,
  subcategoryName,
  sub_category_slug,
  childsubSlug,
}) {
  const dispatch = useAppDispatch()
  const categoryData = useSelector((state: any) => state?.fetchCategory?.categoryData)
  const [nestedChildCategory, setNestedChildCategory] = useState([])
  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    initialSlide: 0,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  }

  const fetchNestedChildCategory = async () => {
    const { data } = await client1.query({
      query: GET_SINGLE_CATEGORY,
      variables: {
        type: 'CHILD_SUB_CATEGORY',
        categoryName: 'Fashion & Accessories',
        subcategoryName: subcategoryName,
        childsubSlug: '',
        nestedSlug: '',
      },
      fetchPolicy: 'network-only',
    })
    
    if (data?.getSingleCategory?.data?.length) {
      setNestedChildCategory(data?.getSingleCategory?.data)
    }
  }

  useEffect(() => {
    fetchNestedChildCategory()
  }, [])

  

  return nestedChildCategory?.length > 0 ? (
    <div>
      <div className={styles.BrowseCatagoryTitle}>
        <h1>Browse by Category</h1>
      </div>
      <div className={styles.BrowseCatagoryMain} style={{ backgroundColor: backgroundColor }}>
        <div className={styles.BrowseCatagorySliderMain}>
          <Slider {...settings}>
            {nestedChildCategory?.map((img) => {
              return (
                <Link href={`/fashion/${subcategoryName}/${img?.slug}`}>
                  <div className={styles.BrowseCatagorySliderboxMain}>
                    <div className={styles.BrowseCatagorySliderbox} style={{ backgroundColor: imageBackgroundColor }}>
                      <img src={img?.media} alt="Bagimage" />
                    </div>
                    <p style={{ color: fontColor }}>{img?.name}</p>
                  </div>
                </Link>
              )
            })}
          </Slider>
        </div>
      </div>
    </div>
  ) : (
    <></>
  )
}
